import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-D_LIh_94.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const LocationFilledSize16Component = (props, ref) => (jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("g", { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.65122 2.47573L3.64722 4.6203C1.63224 5.48386 0.624753 5.91565 0.668024 6.57089C0.711294 7.22614 1.76681 7.52169 3.87785 8.11278L7.0102 8.98984L7.88726 12.1222C8.47835 14.2332 8.7739 15.2887 9.42915 15.332C10.0844 15.3753 10.5162 14.3678 11.3797 12.3528L13.5243 7.34882C15.0725 3.73636 15.8466 1.93013 14.9583 1.04178C14.0699 0.153433 12.2637 0.927532 8.65122 2.47573Z", fill: "var(--magritte-ui-icon-color)" }) }) }) }));
const LocationFilledSize16 = hoc(forwardRef(LocationFilledSize16Component), 'LocationFilledSize16');

export { LocationFilledSize16 as default };
//# sourceMappingURL=LocationFilledSize16.js.map
